import { render, staticRenderFns } from "./ArticleHeaderButton.vue?vue&type=template&id=f081e3a0&scoped=true"
import script from "./ArticleHeaderButton.vue?vue&type=script&lang=js"
export * from "./ArticleHeaderButton.vue?vue&type=script&lang=js"
import style0 from "./ArticleHeaderButton.vue?vue&type=style&index=0&id=f081e3a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f081e3a0",
  null
  
)

export default component.exports